const topics = [
  { name: '暑期档', count: '2.8 万讨论' },
  { name: '长安十二时辰2', count: '2.1 万讨论' },
  { name: '科幻电影推荐', count: '1.9 万讨论' },
  { name: '国漫崛起', count: '1.7 万讨论' },
  { name: '悬疑烧脑', count: '1.5 万讨论' },
  { name: '高分韩剧', count: '1.4 万讨论' },
  { name: '纪录片精选', count: '1.2 万讨论' },
  { name: '经典港片', count: '1.1 万讨论' },
  { name: '治愈系综艺', count: '9800 讨论' },
  { name: '夏日影单', count: '8500 讨论' },
];

export default function TopicsSection() {
  return (
    <section id="topics" className="py-14 md:py-20 bg-background-50">
      <div className="max-w-[1280px] mx-auto px-4 md:px-6">
        <div className="text-center mb-10 md:mb-14">
          <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-950 mb-3">
            热门话题
          </h2>
          <p className="text-sm md:text-base text-foreground-600 max-w-2xl mx-auto">
            影视圈最热话题讨论，加入影迷们的热烈交流
          </p>
        </div>

        <div className="flex flex-wrap justify-center gap-3">
          {topics.map((topic, idx) => (
            <a
              key={idx}
              href="#topics"
              onClick={(e) => e.preventDefault()}
              className="group cursor-pointer bg-background-100 hover:bg-accent-100/70 rounded-full px-5 py-2.5 transition-colors"
            >
              <span className="text-sm font-medium text-foreground-800 whitespace-nowrap">
                # {topic.name}
              </span>
              <span className="text-xs text-foreground-500 ml-2 whitespace-nowrap">
                {topic.count}
              </span>
            </a>
          ))}
        </div>
      </div>
    </section>
  );
}